import { ComponentName, ExtractType } from '@publishing-engine/domain/types';
import { IFormSchema } from '@publishing-engine/domain/models/form-schema';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';

type ISignUpForms = {
  signUpForm: IFormSchema;
};

export class SignUpFormFields {
  private forms: ISignUpForms;

  constructor(signUpForm: IFormSchema) {
    this.forms = {
      signUpForm
    };
  }

  hasField<CN extends ComponentName>(componentName: CN) {
    return Object.values(this.forms).reduce((found, form) => {
      if (found) {
        return true;
      }
      return form.formFields?.some(cfg => cfg.name === componentName) ?? false;
    }, false);
  }

  getFieldConfig<CN extends ComponentName>(componentName: CN) {
    const fieldConfig = Object.values(this.forms).reduce(
      (fieldConfig: FormFieldDefinition | null, form) => {
        if (fieldConfig) {
          return fieldConfig;
        }
        return (
          form?.formFields?.find(cfg => cfg.name === componentName) ?? null
        );
      },
      null
    );

    return fieldConfig as ExtractType<FormFieldDefinition, CN> | null;
  }
}
